import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

const MrnChipRoot = styled(Box)(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  backgroundColor: theme.palette.grey[300],
  color: theme.palette.text.secondary,
  fontWeight: 500,
  fontSize: "12px",
  lineHeight: 1,
  minHeight: "20px",
  padding: "0 8px",
  borderRadius: "4px",
  whiteSpace: "nowrap",
  verticalAlign: "middle",
}));

export const MrnChip = ({ mrn }: { mrn: string }) => (
  <MrnChipRoot data-testid="patient-mrn">{mrn}</MrnChipRoot>
);
